import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SelectButton } from 'primereact/selectbutton';
import { Divider } from 'primereact/divider';
import { Fieldset } from 'primereact/fieldset';
import { TravelStatus } from '../../common/util/constants';
import { travelService } from '../../services/extensions';
import { toast } from 'react-toastify';
import { capitalize } from '../../services/utility/helper';
import { Dialog } from 'primereact/dialog';
import { Card } from 'react-bootstrap';
import { Panel } from 'primereact/panel';
import { Timeline } from 'primereact/timeline';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import moment from 'moment';



const TravelTeamRequestApproval = () => {
    const [selectedLeave, setSelectedLeave] = useState([]);
    const [leaveInReview, setLeaveInReview] = useState([]);
    const [visible, setVisible] = useState(false);
    const [selectedTravelRecord, setSelectedTravelRecord] = useState(null);
    const [visaTypes, setVisaTypes] = useState([]);

    useEffect(() => {
        fetchInReviewTravels();
        getAllVisaTypes()
    }, []);

    //visa
    const getAllVisaTypes = () => {
        travelService.GetAllVisaType()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(visa => ({
                        label: visa.title,
                        value: visa.id
                    }));
                    setVisaTypes(options);
                }
            })
            .catch(error => {
                console.error('Error fetching visa types:', error);
            });
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case TravelStatus.SUBMITTED_TO_APPROVER:
                return 'Submitted to Approver';
            case TravelStatus.APPROVED_BY_MANAGER:
                return 'Approved by Manager';
            case TravelStatus.REJECTED_BY_MANAGER:
                return 'Rejected by Manager';
            case TravelStatus.APPROVED_BY_BU_HEAD:
                return 'Approved by BU Head';
            case TravelStatus.REJECTED_BY_BU_HEAD:
                return 'Rejected by BU Head';
            case TravelStatus.APPROVED_BY_HR_HEAD:
                return 'Approved by HR Head';
            case TravelStatus.REJECTED_BY_HR_HEAD:
                return 'Rejected by HR Head';
            case TravelStatus.APPROVED_BY_CEO:
                return 'Approved by CEO';
            case TravelStatus.REJECTED_BY_CEO:
                return 'Rejected by CEO';
            default:
                return 'Unknown Status';
        }
    };
    const statusBodyTemplate = (rowData) => {
        return rowData.Travels.map(travel => (
            <div key={travel.id}>{getStatusLabel(travel.status)}</div>
        ));
    };

    const visaTypeBodyTemplate = (rowData) => {
        return rowData.Travels.map(travel => (
            <div key={travel.id}>{travel?.visaTypeInfo?.title || 'N/A'}</div>
        ));
    };

    const fetchInReviewTravels = async () => {
        try {
            const resp = await travelService.getUserReviewtravelwithAllStatus();
            const filteredData = resp.data.data.filter(item =>
                item.Travels.some(travel =>
                    [TravelStatus.SUBMITTED_TO_APPROVER, TravelStatus.APPROVED_BY_MANAGER, TravelStatus.REJECTED_BY_MANAGER, TravelStatus.APPROVED_BY_BU_HEAD, TravelStatus.REJECTED_BY_BU_HEAD, TravelStatus.APPROVED_BY_HR_HEAD, TravelStatus.REJECTED_BY_HR_HEAD, TravelStatus.APPROVED_BY_CEO, TravelStatus.REJECTED_BY_CEO].includes(travel.status)
                )
            );
            console.log(filteredData, "filteredData")
            setLeaveInReview(filteredData);
        } catch (error) {
            toast.error('Error fetching data');
        }
    };

    const requestedDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return moment(rowData.Travels[0].createdAt).format('DD/MM/YYYY');
        }
        return 'N/A';
    };

    const journeyDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return rowData.Travels[0].journeyDate ? moment(rowData.Travels[0].journeyDate).format('DD/MM/YYYY') : 'N/A';
        }
        return 'N/A';
    };

    const journeyDateEditor = (options) => {
        const value = options.value ?? options.rowData.Travels?.[0]?.journeyDate;
        return <Calendar
            value={value ? new Date(value) : null}
            onChange={(e) => options.editorCallback(e.value)}
            dateFormat="dd/mm/yy"
            appendTo={document.body}
        />;
    };

    const returnDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return rowData.Travels[0].returnDate ? moment(rowData.Travels[0].returnDate).format('DD/MM/YYYY') : 'N/A';
        }
        return 'N/A';
    };

    const returnDateEditor = (options) => {
        const value = options.value ?? options.rowData.Travels?.[0]?.returnDate;
        return <Calendar
            value={value ? new Date(value) : null}
            onChange={(e) => options.editorCallback(e.value)}
            dateFormat="dd/mm/yy"
            appendTo={document.body}
        />;
    };

    const visaTypeEditor = (options) => {
        const value = options.value ?? options.rowData.Travels?.[0]?.visaType;
        return <Dropdown
            value={value}
            options={visaTypes}
            onChange={(e) => options.editorCallback(e.value)}
            placeholder="Select Visa Type"
            appendTo={document.body}
        />;
    };

    const onRowEditComplete = async (e) => {
        const { newData } = e;
        const travelIds = newData.Travels.map(t => t.id);
        const journeyDate = newData.journeyDate ?? newData.Travels?.[0]?.journeyDate;
        const returnDate = newData.returnDate ?? newData.Travels?.[0]?.returnDate;
        const visaType = newData.visaType ?? newData.Travels?.[0]?.visaType;
        const updateData = {
            Ids: travelIds,
            ...(journeyDate && { journeyDate: moment(journeyDate).format('YYYY-MM-DD') }),
            ...(returnDate && { returnDate: moment(returnDate).format('YYYY-MM-DD') }),
            ...(visaType && { visaType })
        };
        try {
            await travelService.updateTravelVisaType(updateData);
            toast.success('Travel updated successfully');
            fetchInReviewTravels();
        } catch (error) {
            toast.error('Error updating travel');
        }
    };

    const userNameTemplate = (rowData) => {
        return `${rowData.firstName} ${rowData.lastName}`;
    };

    const Designationtitle = (rowData) => {
        return <div>
            <p>{rowData.Designation?.title || 'N/A'}</p>
        </div>
    };

    const BusinessUnittitle = (rowData) => {
        return <div>
            <p>{rowData.BusinessUnit?.title || 'N/A'}</p>
        </div>
    };

    const projectBodyTemplate = (rowData) => {
        return (
            <>
                {rowData.Allocations?.map(allocation => (
                    <div key={allocation.id}>
                        {allocation.Project?.title || 'N/A'} ({allocation.percentage}%)
                    </div>
                ))}
            </>
        );
    };

    const approvesingleRecord = async (rowData) => {
        let param = {
            travels: rowData.Travels.map((e) => e.id),
            status: TravelStatus.APPROVED_BY_HR_HEAD
        };
        try {
            await travelService.ApproveRejecttravelBulk([param]);
            setSelectedLeave([]);
            fetchInReviewTravels();
            toast.success('Record approved successfully');
        } catch (error) {
            toast.error('Error approving record');
        }
    };

    const rejectsingleRecord = async (rowData) => {
        let param = {
            travels: rowData.Travels.map((e) => e.id),
            status: TravelStatus.REJECTED_BY_HR_HEAD
        };
        try {
            await travelService.ApproveRejecttravelBulk([param]);
            setSelectedLeave([]);
            fetchInReviewTravels();
            toast.success('Record rejected successfully');
        } catch (error) {
            toast.error('Error rejecting record');
        }
    };

    const actionBody = (rowData, options) => {
        return (
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                {/* <Button icon="pi pi-check" className="p-button-rounded p-button-primary" onClick={() => approvesingleRecord(rowData)} /> */}
                {/* <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => rejectsingleRecord(rowData)} /> */}
                <Button icon="pi pi-eye" style={{ background: '#6c757d', border: '1px solid #6c757d', borderRadius: '4px', color: '#fff', width: '2rem', height: '2rem', padding: 0 }} onClick={() => handleViewDetail(rowData)} />
                <Button
                    icon={rowData.Travels[0]?.isTravel ? 'pi pi-car' : 'pi pi-ban'}
                    tooltip={rowData.Travels[0]?.isTravel ? 'Mark as Not Travel' : 'Mark as Travel'}
                    tooltipOptions={{ position: 'top' }}
                    style={{ background: rowData.Travels[0]?.isTravel ? '#28a745' : '#dc3545', border: 'none', borderRadius: '4px', color: '#fff', width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => handleMarkAsTravel(rowData)}
                />
                {options.rowEditor?.editing ? (
                    <>
                        <Button icon="pi pi-check" style={{ background: '#6c757d', border: '1px solid #6c757d', borderRadius: '4px', color: '#fff', width: '2rem', height: '2rem', padding: 0 }} onClick={(e) => options.rowEditor.onSaveClick(e)} />
                        <Button icon="pi pi-times" style={{ background: '#6c757d', border: '1px solid #6c757d', borderRadius: '4px', color: '#fff', width: '2rem', height: '2rem', padding: 0 }} onClick={(e) => options.rowEditor.onCancelClick(e)} />
                    </>
                ) : (
                    <Button icon="pi pi-pencil" style={{ background: '#6c757d', border: '1px solid #6c757d', borderRadius: '4px', color: '#fff', width: '2rem', height: '2rem', padding: 0 }} onClick={(e) => options.rowEditor.onInitClick(e)} />
                )}
            </div>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <SelectButton
                //  options={options}
                />
            </React.Fragment>
        );
    };

    const approveLeave = async (selectedLeave) => {
        let idList = [];
        selectedLeave?.map(x => x.Travels?.map(y => {
            idList.push(y.id);
        }));
        let param = {
            travels: idList,
            status: TravelStatus.APPROVED_BY_HR_HEAD
        };
        try {
            await travelService.ApproveRejecttravelBulk([param]);
            toast.success(capitalize(selectedLeave[0].firstName) + " " + capitalize(selectedLeave[0].lastName) + " travels have been approved");
            setSelectedLeave([]);
            fetchInReviewTravels();
        } catch (error) {
            toast.error('Error approving records');
        }
    };

    const rejectLeave = async (selectedLeave) => {
        let idList = [];
        selectedLeave?.map(x => x.Travels?.map(y => {
            idList.push(y.id);
        }));
        let param = {
            travels: idList,
            status: TravelStatus.REJECTED_BY_HR_HEAD,
            reason: "rejected"
        };
        try {
            await travelService.ApproveRejecttravelBulk([param]);
            toast.error(capitalize(selectedLeave[0].firstName) + " " + capitalize(selectedLeave[0].lastName) + " travels have been rejected");
            setSelectedLeave([]);
            fetchInReviewTravels();
        } catch (error) {
            toast.error('Error rejecting records');
        }
    };

    const handleMarkAsTravel = async (rowData) => {
        const travelIds = rowData.Travels.map(t => t.id);
        const currentValue = rowData.Travels[0]?.isTravel ?? false;
        try {
            await travelService.markAsTravel({ Ids: travelIds, isTravel: !currentValue });
            toast.success(`Marked as ${!currentValue ? 'Travel' : 'Not Travel'}`);
            fetchInReviewTravels();
        } catch (error) {
            toast.error('Error updating travel status');
        }
    };

    const handleViewDetail = (rowData) => {
        console.log(rowData, "handleViewDetail")
        setSelectedTravelRecord(rowData);
        setVisible(true);
    };

    return (
        <>
            <div className="col-12">
                <div className="tabview-demo col-12">
                    <Fieldset>
                        <h1>Team Members - Awaiting Approvals</h1>
                        <Divider />
                        <div className="formgrid grid mt-4">
                            <div className="field col-2">
                                {/* <Button label="Approve All"
                                    className="w-100"
                                    style={{ marginRight: "10px" }}
                                    onClick={() => approveLeave(selectedLeave)}
                                    disabled={selectedLeave.length === 0}
                                /> */}
                            </div>
                            <div className="field col-2">
                                {/* <Button label="Reject All"
                                    className="p-button-danger w-100"
                                    onClick={() => rejectLeave(selectedLeave)}
                                    disabled={selectedLeave.length === 0}
                                /> */}
                            </div>
                            <div className="field col-8">
                                <div style={{ textAlign: "right" }}>
                                    {rightToolbarTemplate()}
                                </div>
                            </div>
                        </div>

                        <DataTable
                            // className="mt-4 travels-data"
                            paginator
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            dataKey="id"
                            value={leaveInReview}
                            selection={selectedLeave}
                            onSelectionChange={(e) => setSelectedLeave(e.value)}
                            resizableColumns
                            columnResizeMode="fit"
                            scrollable="horizontal"
                            stripedRows
                            editMode="row"
                            onRowEditComplete={onRowEditComplete}
                        >
                            {/* <Column selectionMode="multiple" headerStyle={{ width: "10px" }}></Column> */}
                            <Column header="Requested Date" body={requestedDateTemplate} />
                            <Column header="ECN" field='ecn' />
                            <Column header="User Name" body={userNameTemplate} />
                            <Column header="Designation" body={Designationtitle} />
                            <Column header="BU" body={BusinessUnittitle} />
                            <Column header="Project" body={projectBodyTemplate} />
                            <Column header="Travel Date" field="journeyDate" body={journeyDateTemplate} editor={journeyDateEditor} />
                            <Column header="Return Date" field="returnDate" body={returnDateTemplate} editor={returnDateEditor} />
                            <Column header="Visa Type" field="visaType" body={visaTypeBodyTemplate} editor={visaTypeEditor} />
                            <Column header="Status" body={statusBodyTemplate} />
                            <Column header="Action" body={actionBody} rowEditor />
                        </DataTable>
                    </Fieldset>
                </div>
            </div>
            <Dialog className="pop-up-dialog add-timesheet custom_popup" header="Travel Details" visible={visible} modal style={{ width: '700px' }} onHide={() => setVisible(false)} draggable={false} resizable={false}>
                {selectedTravelRecord && selectedTravelRecord.Travels && selectedTravelRecord.Travels.map((travel, index) => (
                    <Panel key={travel.id} className='traveldetail'>
                        <div className='formgrid grid'>
                            <div className='col-12'>
                                <Card>
                                    <div className='d-flex-space-bet'>
                                        <h1>Basic Detail</h1>
                                    </div>
                                    <hr />
                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Trip Type</h2>
                                            <p>{travel.tripTypeInfo?.title || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Visa Type</h2>
                                            <p>{travel.visaTypeInfo?.title || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>User ECN</h2>
                                            <p>{travel.empEcn || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Manager ECN</h2>
                                            <p>{travel.managerEcn || 'N/A'}</p>
                                        </div>
                                    </div>

                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Traveller Name</h2>
                                            <p>{selectedTravelRecord.firstName} {selectedTravelRecord.lastName}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Surname</h2>
                                            <p>{selectedTravelRecord.lastName}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>User Name</h2>
                                            <p>{selectedTravelRecord.firstName}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Designation</h2>
                                            <p>{selectedTravelRecord.Designation?.title || 'N/A'}</p>
                                        </div>
                                    </div>

                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Mobile Number</h2>
                                            <p>{selectedTravelRecord.phone || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Email ID</h2>
                                            <p>{selectedTravelRecord.email || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Grade</h2>
                                            <p>{travel.grade || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Traveller Comments</h2>
                                            <p>{travel.comment || 'N/A'}</p>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            <div className='col-12'>
                                <Card>
                                    <div className='d-flex-space-bet'>
                                        <h1>Traveller Detail</h1>
                                    </div>
                                    <hr />
                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Client Name</h2>
                                            <p>{selectedTravelRecord?.Travels[0]?.customerInfo?.title || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Project Name</h2>
                                            <p>{selectedTravelRecord?.Allocations[0]?.Project?.title || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Project Manager</h2>
                                            <p>{selectedTravelRecord?.Allocations[0]?.Project?.pm?.firstName + " " + selectedTravelRecord?.Allocations[0]?.Project?.pm?.lastName || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>BU/Functional Head</h2>
                                            <p>{selectedTravelRecord?.BusinessUnit?.title || 'N/A'}</p>
                                        </div>
                                    </div>
                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Country of Visit</h2>
                                            <p>{selectedTravelRecord?.Travels[0]?.countryInfo?.countryName || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>State/Cities</h2>
                                            <p>{selectedTravelRecord?.Travels[0]?.stateInfo?.stateName || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Journey Date</h2>
                                            <p>{travel.journeyDate ? moment(travel.journeyDate).format('DD/MM/YYYY') : 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Return Date</h2>
                                            <p>{travel.returnDate ? moment(travel.returnDate).format('DD/MM/YYYY') : 'N/A'}</p>
                                        </div>
                                    </div>
                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Cost Center</h2>
                                            <p>{travel.costCenter || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>DA Currency</h2>
                                            <p>{travel.daCurrency || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>DA Entitle Amount</h2>
                                            <p>{travel.daentitleAmmount || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Seat Request</h2>
                                            <p>{travel.seatRequest || 'N/A'}</p>
                                        </div>
                                    </div>
                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Meal Request</h2>
                                            <p>{travel.mealRequest || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Frequently Flyer Number</h2>
                                            <p>{travel.frequentflyerNumber || 'N/A'}</p>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            <div className='col-12'>
                                <Card>
                                    <div className='d-flex-space-bet'>
                                        <h1>Passport Detail</h1>
                                    </div>
                                    <hr />
                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Passport Number</h2>
                                            <p>{travel.travelDetails?.[0]?.passportNumber || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Date of Birth</h2>
                                            <p>{travel.travelDetails?.[0]?.dateOfBirth ? moment(travel.travelDetails[0].dateOfBirth).format('DD/MM/YYYY') : 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Place of Issue</h2>
                                            <p>{travel.travelDetails?.[0]?.placeOfIssue || 'N/A'}</p>
                                        </div>
                                        <div className='field col-3 single-category'>
                                            <h2>Issue of Passport</h2>
                                            <p>{travel.travelDetails?.[0]?.dateOfIssueOfPassport ? moment(travel.travelDetails[0].dateOfIssueOfPassport).format('DD/MM/YYYY') : 'N/A'}</p>
                                        </div>
                                    </div>
                                    <div className="formgrid grid">
                                        <div className='field col-3 single-category'>
                                            <h2>Expire In Passport</h2>
                                            <p>{travel.travelDetails?.[0]?.dateOfexpireOfPassport ? moment(travel.travelDetails[0].dateOfexpireOfPassport).format('DD/MM/YYYY') : 'N/A'}</p>
                                        </div>
                                        <div className='field col-6 single-category'>
                                            <h2>Address as per the Passport</h2>
                                            <p>{travel.travelDetails?.[0]?.addressAsPerthefPassport || 'N/A'}</p>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            <div className='col-12'>
                                <Card>
                                    <div className='d-flex-space-bet'>
                                        <h1>Insurance Detail</h1>
                                    </div>
                                    <hr />
                                    <div className="formgrid grid">
                                        <div className='field col-4 single-category'>
                                            <h2>Current Residence Address</h2>
                                            <p>{travel.travelDetails?.[0]?.currentResidenceAddress || 'N/A'}</p>
                                        </div>
                                        <div className='field col-4 single-category'>
                                            <h2>Nominee Name</h2>
                                            <p>{travel.travelDetails?.[0]?.nomineeName || 'N/A'}</p>
                                        </div>
                                        <div className='field col-4 single-category'>
                                            <h2>Relation With Nominee</h2>
                                            <p>{travel.travelDetails?.[0]?.relationWithNominee || 'N/A'}</p>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </Panel>
                ))}
            </Dialog>
        </>
    );
};

export default TravelTeamRequestApproval;
